"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchActivityMeta = fetchActivityMeta;
exports.getOpportunityAndActivityIdsByOpportunityActivityId = getOpportunityAndActivityIdsByOpportunityActivityId;
const common_1 = require("@nestjs/common");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
/**
 * Fetches activity meta for a given opportunity ID.
 * @param repository - The repository for OpportunityActivityMap.
 * @param opportunityId - The opportunity ID.
 * @returns A promise resolving to the activity meta data.
 */
async function fetchActivityMeta(repository, opportunityId, refActivityId) {
    try {
        if (!opportunityId || !refActivityId) {
            throw new common_1.NotFoundException("Invalid opportunity or activity ID.");
        }
        const activitymeta = await repository.find({
            where: { opportunityId, refActivityId },
            select: ["id", "activityName", "activityMeta", "statusLid"],
        });
        if (!activitymeta || activitymeta.length === 0) {
            throw new common_1.NotFoundException(messages_1.errorMessages.opportunityActivityMetaNotFound);
        }
        return activitymeta[0];
    }
    catch (error) {
        throw new common_1.NotFoundException(messages_1.errorMessages.opportunityActivityMetaNotFound, error.message);
    }
}
async function getOpportunityAndActivityIdsByOpportunityActivityId(repository, activityRepository, opportunityActivityId) {
    try {
        if (!opportunityActivityId) {
            throw new common_1.NotFoundException("Invalid opportunity activity ID.");
        }
        const result = await repository.findOne({
            where: { id: opportunityActivityId },
            select: [
                "opportunityId",
                "refActivityId",
                "dueDate",
                "activityName",
                "activityKey",
                "leadDays",
            ],
        });
        if (!result) {
            throw new common_1.NotFoundException(`Opportunity activity not found for ID: ${opportunityActivityId}`);
        }
        const opportunityActivity = await activityRepository.findOne({
            where: { id: result.refActivityId },
            select: ["opportunityTable"],
        });
        if (!opportunityActivity) {
            throw new common_1.NotFoundException(`Opportunity Table not found for activity ID: ${result.refActivityId}`);
        }
        return {
            opportunityId: result.opportunityId,
            activityId: result.refActivityId,
            plannedDate: result.dueDate,
            opportunityTable: opportunityActivity.opportunityTable,
            activityName: result.activityName,
            activityKey: result.activityKey,
            leadDays: result.leadDays,
        };
    }
    catch (error) {
        throw new common_1.NotFoundException(`Error fetching opportunity and activity IDs: ${error.message}`);
    }
}
